import $ from 'jquery';
import '@chenfengyuan/datepicker';
import '../../portal/js/confirm/queue';

$(function () {

    const $form = $('#step1Form');

    if (!$form.length) {
        return;
    }

    const sectionPrices   = $form.find('form').data('section-prices');
    const isArchived      = $form.find('form').data('archived');
    const sailBoatOffered = $form.find('form').data('sail-boat-offered');

    // Employer selection
    const $employerSelect              = $form.find('#employer');
    const $organizationalUnit          = $form.find('#organizationalUnit');
    const $sectionCheckboxes           = $form.find("[name='sections[]']");
    const $sailboatSectionLabelSuffix  = $sectionCheckboxes
        .filter('[value=9]')
        .first()
        .closest('.form-group')
        .find('label .suffix');

    const $tennisSquashAdditional   = $('#tennisSquashAdditional');

    const $sailboatAdditional = $('#sailboatAdditional');
    const $sailboatCheckbox = $sectionCheckboxes.filter('[id="section-sailboat"]').first();

    let isInvitation                = !!$form.find('[name=invitation_code]').length;
    let isInvited                   = !!$form.find('form').data('is-invited');
    const $sections                 = $form.find('#sections');
    const $employerInputs           = $form.find('#employerInputs');
    const $kidCheckbox              = $form.find('[name=is_kid]');
    const $paymentMethodSelect      = $form.find('#paymentMethod');
    const $szepCardDetails          = $form.find('#szepCardDetails');
    const $cancelInvitation         = $form.find('#cancelInvitation');
    const $cancelInvitationCheckbox = $form.find('#cancelInvitationCheckbox');


    $employerSelect
        .on('change', function () {

            const val = $(this).val();

            if (val !== 'other') {
                $organizationalUnit.show();
            } else {
                $organizationalUnit.hide();
            }

        })
        .trigger('change');

    const $titleSelect        = $form.find('#title');
    const $kidTitleOption     = $titleSelect.find('option[value=kid]');
    const $taxNumberContainer = $form.find('#taxNumberContainer');

    function inactivateAllSections() {
        $form.find('input[name="sections[]"').each(function () {
            inactivateSection($(this));
        });
    }

    function activateAllSections() {
        $form.find('input[name="sections[]"').each(function () {
            activateSection($(this));
        });
    }

    function inactivateSection($input) {

        $input
            .attr('disabled', 'disabled')
            .closest('.form-group')
            .addClass('d-none');
    }

    function activateSection($input) {

        $input
            .closest('.form-group')
            .removeClass('d-none');

        if (!$input.data('paid')) {
            $input.removeAttr('disabled');
        }
    }

    function updateSectionPrices(title, isKid) {

        if (isKid) {
            title = 'kid';
        }

        $(sectionPrices).each(function (index, sectionPrice) {

            const $input = $sectionCheckboxes.filter(`#section${sectionPrice.id}`).first();

            if (!$input.length) {
                return;
            }

            const $priceContainer = $input.closest('.form-group').find('.price');
            let price             = 0;

            // Set title specific price.
            if (typeof sectionPrice.prices[title] !== "undefined") {

                price = sectionPrice.prices[title];
            } else if (sailBoatOffered && (isKid || title === 'belonging') && sectionPrice.id === 9) {

                price = 0;
            }
            // Fall back to original price.
            else {

                price = sectionPrice.price;
            }

            $priceContainer.text(price);

        });
    }

    function toggleSailboatAdditional() {
        $sailboatAdditional.toggle($(this).is(':checked'));
    }

    var prevTitle = null;

    function renderByTitle(title) {

        $sailboatCheckbox.off('change', toggleSailboatAdditional)

        $sailboatCheckbox
            .on('change', function () { console.log('asd')})
            .trigger('change');

        $sailboatCheckbox
            .on('change', toggleSailboatAdditional)
            .trigger('change');


        if (!title && $titleSelect.length) {
            $sections.children().first().addClass('d-none');
            $sections.children().last().removeClass('d-none');
            return;
        } else {
            $sections.children().first().removeClass('d-none');
            $sections.children().last().addClass('d-none');
            prevTitle = title;
        }

        if (prevTitle !== title) {
            $sections.find('input[type=email]').val('');
            $sections.find('input[type=checkbox]').prop('checked', false);
        }

        if (title === 'support_member') {

            activateAllSections();

        } else {
            activateAllSections();
        }

        const isKid = title === 'kid' || ($kidCheckbox.length && $kidCheckbox.is(':checked'));

        if (isKid || title === 'support_member' || title === 'belonging') {
            $employerInputs.addClass('d-none');
        } else {
            $employerInputs.removeClass('d-none');
        }

        if (isKid || (title === 'belonging' && sailBoatOffered)) {
            $sailboatSectionLabelSuffix.text('(utánpótlás tag)');
        } else {
            $sailboatSectionLabelSuffix.text('');
        }

        updateSectionPrices(title, isKid);

    }

    $titleSelect
        .on('change', function () {
            renderByTitle($(this).val());
        })
        .trigger('change');

    var $fixedTitle = $('#fixedTitle');
    if (!$titleSelect.length && $fixedTitle.length) {

        renderByTitle($fixedTitle.val());
    }

    var $hiddenTitle = $('input[type=hidden][name="job[title]"]');
    if ($hiddenTitle.length) {

        renderByTitle($hiddenTitle.val());
    }

    if ($titleSelect.length && !$titleSelect.val()) {
        $sections.children().last().removeClass('d-none');
        $sections.children().first().addClass('d-none');
    } else if ($fixedTitle.length) {
        $sections.children().first().removeClass('d-none');
        $sections.children().last().addClass('d-none');
    }

    if ($kidCheckbox.length) {

        $kidCheckbox
            .on('change', function () {

                const fallbackTitle = $hiddenTitle.val() ? $hiddenTitle.val() : $fixedTitle.val();
                const value         = $(this).is(':checked') ? 'kid' : fallbackTitle;

                renderByTitle(value);
                updateSectionPrices(value);
            })
            .trigger('change');
    }


    function showSzepCardDetails() {
        $szepCardDetails.show()
            .find('input');
    }

    function hideSzepCardDetails() {
        $szepCardDetails.hide()
            .find('input');
    }

    $paymentMethodSelect
        .on('change', function () {

            const val = $(this).val();

            val === 'szep_card'
                ? showSzepCardDetails()
                : hideSzepCardDetails();

        })
        .trigger('change');

    function processBirthDate(birthDate) {

        if(isArchived && $fixedTitle.val() === 'belonging') {

            return;
        }

        const d1        = new Date().getTime() / 86400000;
        const d2        = birthDate.getTime() / 86400000;
        const diffYears = Math.abs((d2 - d1) / 365);

        // Change title / checkbox if needed.
        if (diffYears <= 18) {

            // Explicitly set kid as value.
            $kidTitleOption.removeAttr('hidden').show();

            // Disable other options.
            $titleSelect.attr('readonly', 'readonly').find('option[value!="kid"]').attr('disabled', 'disabled');

            $titleSelect.val('kid').trigger('change');
            $kidCheckbox.prop('checked', true).trigger('change');
        } else {

            // Reset selection to the first (invalid) option.
            $kidTitleOption.attr('hidden', 'hidden').hide();

            // Enable other options.
            $titleSelect.removeAttr('readonly').find('option').removeAttr('disabled');

            if ($titleSelect.val() === 'kid') {
                $titleSelect.prop('selectedIndex', 0).trigger('change');
            }

            $kidCheckbox.prop('checked', false).trigger('change');
        }
    }

    $form
        .find('#birthDate')
        .on('pick.datepicker', function (e) {

            if ($hiddenTitle.length && $hiddenTitle.val() === 'support_member') {
                return;
            }

            processBirthDate(e.date);
        })
        .on('change', function (e) {

            const $e  = $(this);
            const val = $e.val();

            if (/^[0-9]{4}-[0-9]{2}-[0-9]{2}$/.test(val)) {

                const parts = val.split('-');
                const date  = new Date();
                date.setFullYear(parseInt(parts[0]), parseInt(parts[1]), parseInt(parts[2]));
                $e.removeClass('is-invalid');

                if ($hiddenTitle.length && $hiddenTitle.val() === 'support_member') {
                    return;
                }

                processBirthDate(date);
            } else {

                $e.addClass('is-invalid');
            }
        })
        .trigger('change');

    const originalSupportMemberEmail = $tennisSquashAdditional.find('input[type=email]').val();

    $('#deleteSupportMember').on('click', function () {
        $tennisSquashAdditional.find('input[type=email]').val('');
        $form.find('form').trigger('submit');
    });

    $form.find('form').on('submit', function (e) {

        if (!originalSupportMemberEmail.length) {
            return;
        }

        const $input                = $tennisSquashAdditional.find('input[type=email]');
        const newSupportMemberEmail = $input.val();
        const $form                 = $(this);
        const $btn                  = $(this).find('button[type=submit]');

        if (!$input.hasClass('is-invalid') && originalSupportMemberEmail !== newSupportMemberEmail) {

            const msg = !newSupportMemberEmail.trim().length
                ? 'Ön törölni készül korábban meghívott pártoló tagját. Biztosan megteszi?'
                : 'Ön egy új pártoló tag email címet adott meg. A korábbi pártoló tag törlésre fog kerülni! Biztosan új pártoló tagot hív meg?';

            if (!confirm(msg)) {
                e.preventDefault();
                setTimeout(function () {
                    $form.removeData('submitted');
                    $btn.removeAttr('disabled');
                }, 5);
            }
        }
    });

    $titleSelect.on('change', function (e, ignoreWarn) {

        if (!!ignoreWarn) {
            return;
        }

        if (isArchived) {

            let warnedTitles         = [
                'support_member',
                'belonging'
            ];
            const originalTitle      = $fixedTitle.val();
            const newTitle           = $(this).val();
            const userShouldBeWarned = isInvited && warnedTitles.includes($fixedTitle.val()) && !warnedTitles.includes(newTitle);

            if (userShouldBeWarned) {

                window.confirmDialog(
                    'Jogcím megváltoztatása',
                    'Jogcímének megváltoztatásával megszűnik az Önt meghívó személy meghívása. A művelet nem visszavonható! Biztosan új jogcímet szeretne beállítani?'
                )
                    .then(
                        function () {
                            $cancelInvitation.parent().hide();
                        },
                        function () {

                            if (!$titleSelect.find(`option[value=${originalTitle}]`).length) {

                                $titleSelect.val('').trigger('change', true);
                            } else {

                                $titleSelect
                                    .val(originalTitle)
                                    .trigger('change', true);
                            }
                        }
                    );
            }

            if ($cancelInvitation.length &&
                originalTitle !== newTitle &&
                newTitle === 'support_member') {

                $cancelInvitation.parent().show();
            }

        }

    });

    $cancelInvitation.on('click', function (e) {

        e.preventDefault();

        window.confirmDialog(
            'Meghívó elutasítása',
            'Meghívójának elutasításával önálló MAVIR SE tagsága lehet, azonban kérjük vegye figyelembe, hogy a Tenisz-squash szakosztályra való jelentkezés nem lesz lehetséges!'
        )
            .then(
                function () {
                    $cancelInvitationCheckbox.val(1);
                    $cancelInvitation.parent().hide();
                    isInvited = false;
                    $titleSelect.trigger('change');
                }
            );


    });

});
